let http = ''
if (process.env.NODE_ENV === 'development') {
  http = '/static/images/'
} else {
  // http = 'http://staticnova.ruoogle.net/face_download/img/'
  http = '/static/images/'
}
function disposeSrc (name) {
  return `${http}${name}`
}
export default disposeSrc



// WEBPACK FOOTER //
// ./src/config/http.js